/*
 * @Author: Ygm
 * @Date: 2024-05-09 15:26:55
 * @LastEditors: Ygm
 * @LastEditTime: 2024-05-09 15:26:55
 * @Description: 动态获取当前屏幕视口的宽度
 */
// 定义一个变量用于保存当前屏幕视口宽度
let viewportWidth = window.innerWidth

// 创建一个函数用于更新 viewportWidth 变量
function updateViewportWidth() {
  viewportWidth = window.innerWidth
}

// 监听窗口大小变化事件，并在发生变化时更新 viewportWidth 变量
window.addEventListener('resize', updateViewportWidth)

// 将 viewportWidth 挂载到 window 对象上，使其全局可用
if (window) {
  window.viewportWidth = viewportWidth
}



// WEBPACK FOOTER //
// ./src/utils/viewportWidth.js